var map = {
	"./directives/templates/developerMetricsAvailable.html": 177,
	"./directives/templates/friendRequest.html": 6610,
	"./directives/templates/gameUpdateActionPopoverTemplate.html": 4970,
	"./directives/templates/gameUpdateTemplate.html": 5931,
	"./directives/templates/notificationContent.html": 2008,
	"./directives/templates/notificationContentViewTemplate.html": 6763,
	"./directives/templates/notificationStreamBaseView.html": 643,
	"./directives/templates/notificationStreamContainer.html": 5091,
	"./directives/templates/privateMessage.html": 9488,
	"./directives/templates/test.html": 5980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6012;